<template>
  <div class="more">
    <router-link :to="justify" title="更多訊息" @click="setSearchData">
      <div class="plus"><i class="fas fa-plus"></i></div>
      <p :style="{ fontSize: fontSize.p + 'em' }">更多訊息</p>
    </router-link>
  </div>
</template>

<script>
//  無障礙文字子層引入設定
import { inject } from "vue";
import { useStore } from "vuex";
export default {
  name: "More",
  props: {
    link: {
      type: Object,
      required: true,
    },
    justify: {
      type: String,
      required: true,
    },
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    const store = useStore();
    const setSearchData = () => {
      store.dispatch("setSearchData", {
        keyword: "",
        page: 0,
      });
    };
    return {
      fontSize,
      setSearchData,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
